import {
  IChipsData,
  Country,
  DataProvider,
  ErrorsInterface,
  ObjectValue,
} from '@/types';

export interface InventoryState {
  inventory: IStateInventory | null;
  placements: IStatePlacements;
  placementContents: IStateContents;
  placementWidgetParams: IStatePlacementWidgetParams;
  inventoryList: DataProvider;
  isSavingForm: boolean;
}

export interface Inventory {
  name: string;
  domain: string;
  languages: Array<Country>;
  status: ObjectValue | null;
  moderation_status: ObjectValue | null;
  errors: ErrorsInterface;
  categories: Array<IChipsData>;
  placements: Array<Placement>;
}

export interface IStateInventory {
  id: string;
  name: string;
  domain: string;
  status: string;
  languages: Array<string>;
  categories: Array<string>;
  placements: Array<string>;
  errors: ErrorsInterface;
}

export interface Placement {
  id: string;
  name: string;
  type: string;
  unwantedCategories: Array<string>;
  unwantedLinks: Array<string>;
  contents: Array<string>;
  emptySlotType: string;
  showContentAddButton?: boolean;
  showUnwantedContentAddButton?: boolean;
  errors: ErrorsInterface;
}

export interface IWidgetParams {
  type: string;
  element: string;
  width: number | string;
  height: number | string;
  cols: number | string;
  rows: number | string;
  useMaxHeight: number;
  maxHeight: number | string;
  typeDevice: string;
  position: string;
  mobileVerticalMargin: number | string;
  desktopVerticalMargin: number | string;
  desktopHorizontalMargin: number | string;
  openTriggerType: string;
  openTriggerValue: string | number;
  useCloseTrigger: number;
  closeTriggerType: string;
  closeTriggerValue: string | number;
  errors: ErrorsInterface;
}

export type TPlacementWidgetParams =
  | IBannerWidgetParams
  | INativeWidgetParams
  | IPushWidgetParams;

export interface IBannerWidgetParams {
  placement_type: string;
  element: string;
  width: number;
  height: number;
}

export interface INativeWidgetParams {
  placement_type: string;
  element: string;
  width: number;
  height: number;
  cols: number;
  rows: number;
  useMaxHeight: number;
  maxHeight: number;
  bids: Array<any>;
}

export interface IPushWidgetParams {
  placement_type: string;
  typeDevice: string;
  verticalPosition: string;
  horizontalPosition: string;
  mobileVerticalMargin: number;
  desktopVerticalMargin: number;
  desktopHorizontalMargin: number;
  width: number;
  height: number;
  openTrigger: string;
  openTimeout: number;
  openAnchor: string;
  openScroll: number;
  useCloseTrigger: number;
  closeTrigger: string;
  closeScroll: number;
  closeTimeout: number;
  bids: Array<any>;
}

export interface IStatePlacements {
  byId: { [id: string]: Placement };
  allIds: Array<string>;
}

export interface IStateContents {
  byId: { [id: string]: Content };
  allIds: Array<string>;
}


export interface IStatePlacementWidgetParams {
  byId: { [id: string]: IWidgetParams };
  allIds: Array<string>;
}

export interface Content {
  id: string;
  title?: string | null;
  description?: string | null;
  link: string;
  img?: string | null | ArrayBuffer;
  creative?: ContentImage;
  isChoosedImage?: boolean;
  isEdited?: boolean;
}

export interface ContentImage {
  id?: number | null;
  file?: File | null;
  img?: string | null | ArrayBuffer;
  width?: number | null;
  height?: number | null;
}

export interface UnwandedContents {
  links?: Array<string>;
  categories?: Array<IChipsData>;
}

export interface PushTrigger {
  type: string;
  value: string | number;
}

export type TNewData = {
  propName: string;
  value: any;
};

export type TNewDataWithId = {
  id: string;
  propName: string;
  value: any;
};

export type TSubmitData = {
  APIName: string;
  inventoryId?: string;
};

export type TRequestData = {
  formData: any;
  id?: number | string;
};

export type TInventoryData = {
  inventory: IStateInventory;
  placements: IStatePlacements;
  placementWidgetParams: IStatePlacementWidgetParams;
};

export enum ETimeout {
  T_1 = '1000',
  T_5 = '5000',
  T_10 = '10000',
  T_20 = '20000',
  T_30 = '30000',
  T_60 = '60000',
}

export enum ETrigger {
  TIMEOUT = 'timeout',
  ANCHOR_ID = 'anchor_id',
  ANCHOR_CLASS = 'anchor_class',
  SCROLL = 'scroll',
}

export enum EPosition {
  TOP_RIGHT = 'top_right',
  TOP_LEFT = 'top_left',
  BOTTOM_RIGHT = 'bottom_right',
  BOTTOM_LEFT = 'bottom_left',
}

export enum EEmptySlotTypes {
  CUSTOM = 'custom',
  AUTO = 'auto',
}

export enum EDefaultNativeSize {
  width = 600,
  height = 400,
}

export enum EDefaultPushSize {
  width = 200,
  height = 200,
}
